import { Icon, IconProps } from "@chakra-ui/react";

export const Rabbit = (props: IconProps) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 216" fill="none" {...props}>
      <path fill="#8C5E32" d="M28 200h8v4h-8z" />
      <path fill="#B5874E" d="M32 196h8v4h-8z" />
      <path fill="#A67B47" d="M28 196h4v4h-4z" />
      <path fill="#C69455" d="M36 184h-4v4h4v-4ZM56 188h-4v8h-4v4h16v-4h-4v-4h-4v-4ZM32 192h4v4h-4v-4Z" />
      <path fill="#A56F3B" d="M52 192h-4v4h4v-4ZM36 200h4v4h-4v-4ZM48 200h16v4H48v-4Z" />
      <path fill="#495563" d="M40 148h-4v4h-4v4h8v-8ZM36 160h-4v24h4v-24ZM48 160h4v24h-4v-24ZM48 152h4v-4h4v8h-8v-4Z" />
      <path fill="#3B2513" d="M32 24h-4v4h4v-4ZM36 48h-4v8h4v-8Z" />
      <path fill="#21150B" d="M32 28h-4v4h4v8h4v-8h-4v-4ZM36 48h4v8h-4v-8Z" />
      <path fill="#F2AEDD" d="M40 20h-4v12h4V20ZM60 20h-4v12h-8v4h-4v8h-4v4h8V36h4v4h4v4h-4v4h8v-8h-4v-8h4V20Z" />
      <path fill="#A2828D" d="M48 44h4v4h-4z" />
      <path fill="#F5E1EB" d="M48 48h4v4h-4z" />
      <path fill="#F62578" d="M44 40h-4v4h4v-4ZM56 40h-4v4h4v-4Z" />
      <path fill="#C48DB3" d="M48 28h4v4h-4v-4ZM48 52v-4h-8v4h8ZM56 48h-4v4h4v-4ZM44 32h-4v4h4v-4Z" />
      <path fill="#D79AC4" d="M52 28h4v4h-4v-4ZM48 32h-4v4h-4v4h-4v8h4v-8h4v-4h4v8h4v-8h-4v-4Z" />
      <path
        fill="#A87999"
        d="M36 16h4v4h-4v-4ZM36 32V20h-4v12h4ZM40 32h-4v8h-4v8h4v-8h4v-8ZM40 32v-4h8v4h-8ZM56 20h-4v8h4v-8ZM56 20h4v-4h-4v4Z"
      />
      <path fill="#162232" d="M60 64h-4v8h-4v76h4V80h4v32h4V72h-4v-8Z" />
      <path
        fill="#162232"
        fillRule="evenodd"
        d="M32 68h8v4h4v4h4v72H36V84h-4v-4h-4v32h-4V76h4v-4h4v-4Zm8 60h4v-4h-4v4Zm4-24v4h-4v-4h4Zm-4-16h4v-4h-4v4Z"
        clipRule="evenodd"
      />
      <path
        fill="#06090D"
        d="M36 60h4v4h-4v-4ZM32 68v-4h4v4h-4ZM28 72v-4h4v4h-4ZM24 76v-4h4v4h-4ZM24 76v36h-4V76h4ZM48 76h4v68h-4V76ZM56 80h4v32h-4V80Z"
      />
      <path
        fill="#06090D"
        d="M36 84h-4v-4h-4v8h4v24h-4v16h-4v12h-4v8h16V84ZM56 60h-4v8h-4v4h4v-4h4v-8ZM44 84h-4v4h4v-4ZM40 104h4v4h-4v-4ZM44 124h-4v4h4v-4Z"
      />
      <path fill="#17110C" d="M20 116h-4v4h4v-4ZM20 124h-4v16h4v-16Z" />
      <path fill="#9E7755" d="M16 140h4v44h-4z" />
      <path fill="#856448" d="M16 144h-4v44h8v-4h-4v-40Z" />
      <path fill="#F0B482" d="M40 52h4v4h4v4h-4v4h-4V52ZM20 112h-4v4h4v-4ZM20 120h-4v4h4v-4Z" />
      <path fill="#FCC02E" d="M36 64h4v4h-4v-4ZM44 72h-4v-4h4v4ZM52 72h-8v4h8v-4ZM52 72v-4h4v4h-4Z" />
      <path
        fill="#FFD99C"
        d="M52 52h-8v4h8v-4ZM44 60h4v4h4v4h-4v4h-4v-4h-4v-4h4v-4ZM20 112h4v8h-4v-8ZM64 112v8h-4v-4h-4v-4h8ZM60 120v4h-4v-4h4Z"
      />
      <path fill="#252D33" d="M48 144h4v8h-4v4h4v4h-4v28h-4v-40h4v-4ZM28 148v36h4v-24h4v-4h-4v-4h4v-4h-8Z" />
      <path fill="#302725" d="M28 184h4v4h-4v-4ZM36 188v4h-4v-4h4ZM36 188v-4h4v4h-4ZM48 192v-8h8v4h-4v4h-4Z" />
      <path fill="#343436" d="M8 200h8v4H8v-4ZM20 200h8v4h-8v-4ZM64 204H48v-4h-8v4H28v4h36v-4ZM64 204v-4h8v4h-8Z" />
      <g
        fill="#0A8F4F"
        style={{
          mixBlendMode: "color",
        }}
      >
        <path
          fillRule="evenodd"
          d="M36 16h4v12h12v-8h4v-4h4v16h-4v8h4v8h-4v4h-4v4h-4v8h4v-4h4v4h4v8h4v48h-4v-4h-4v4h4v4h-4v32h-4v28h4v8h4v4h4v4h8v4h-8v4H28v-4h-8v-4h8v-4h4v-8h-4v-40h-8v40h-8v-44h4v-32h4V76h4v-4h4v-4h4v-4h4v-4h4v-4h-8V32h-4v-8h4v-4h4v-4Zm4 184h8v-12h-4v-40h-4v8h-4v28h4v4h-4v8h4v4Zm-20-80h4v-8h4v16h-4v12h-4v-20Zm8-8V88h4v24h-4Z"
          clipRule="evenodd"
        />
        <path d="M16 204v-4H8v4h8Z" />
      </g>
    </Icon>
  );
};

export const RabbitIcon = ({ color, ...props }: IconProps) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M9 4.5H7.5V6H9V4.5Z" fill="#3B2513" />
      <path d="M10.5 13.5H9V16.5H10.5V13.5Z" fill="#3B2513" />
      <path d="M9 6H7.5V7.5H9V10.5H10.5V7.5H9V6Z" fill="#21150B" />
      <path d="M10.5 13.5H12V16.5H10.5V13.5Z" fill="#21150B" />
      <path d="M12 3H10.5V7.5H12V3Z" fill="#F2AEDD" />
      <path
        d="M19.5 3H18V7.5H15V9H13.5V12H12V13.5H15V9H16.5V10.5H18V12H16.5V13.5H19.5V10.5H18V7.5H19.5V3Z"
        fill="#F2AEDD"
      />
      <rect x="15" y="12" width="1.5" height="1.5" fill="#A2828D" />
      <rect x="15" y="13.5" width="1.5" height="1.5" fill="#F5E1EB" />
      <path d="M13.5 10.5H12V12H13.5V10.5Z" fill="#F62578" />
      <path d="M18 10.5H16.5V12H18V10.5Z" fill="#F62578" />
      <path d="M15 6H16.5V7.5H15V6Z" fill="#C48DB3" />
      <path d="M15 15V13.5H12V15H15Z" fill="#C48DB3" />
      <path d="M18 13.5H16.5V15H18V13.5Z" fill="#C48DB3" />
      <path d="M13.5 7.5H12V9H13.5V7.5Z" fill="#C48DB3" />
      <path d="M16.5 6H18V7.5H16.5V6Z" fill="#D79AC4" />
      <path d="M15 7.5H13.5V9H12V10.5H10.5V13.5H12V10.5H13.5V9H15V12H16.5V9H15V7.5Z" fill="#D79AC4" />
      <path d="M10.5 1.5H12V3H10.5V1.5Z" fill="#A87999" />
      <path d="M10.5 7.5V3H9V7.5H10.5Z" fill="#A87999" />
      <path d="M12 7.5H10.5V10.5H9V13.5H10.5V10.5H12V7.5Z" fill="#A87999" />
      <path d="M12 7.5V6H15V7.5H12Z" fill="#A87999" />
      <path d="M18 3H16.5V6H18V3Z" fill="#A87999" />
      <path d="M18 3H19.5V1.5H18V3Z" fill="#A87999" />
      <path d="M21 24H16.5V22.5H18V19.5H19.5V22.5H21V24Z" fill="#162232" />
      <path d="M7.5 24H13.5V22.5H12V21H9V22.5H7.5V24Z" fill="#162232" />
      <path d="M12 18H10.5V19.5H9V21H7.5V22.5H6V24H7.5V22.5H9V21H10.5V19.5H12V18Z" fill="#06090D" />
      <path d="M18 18H16.5V21H15V22.5H16.5V21H18V18Z" fill="#06090D" />
      <path d="M12 15H13.5V16.5H15V18H13.5V19.5H12V15Z" fill="#F0B482" />
      <path d="M10.5 19.5H12V21H10.5V19.5Z" fill="#FCC02E" />
      <path d="M13.5 22.5H12V21H13.5V22.5Z" fill="#FCC02E" />
      <path d="M16.5 22.5H13.5V24H16.5V22.5Z" fill="#FCC02E" />
      <path d="M16.5 22.5V21H18V22.5H16.5Z" fill="#FCC02E" />
      <path d="M16.5 15H13.5V16.5H16.5V15Z" fill="#FFD99C" />
      <path d="M13.5 18H15V19.5H16.5V21H15V22.5H13.5V21H12V19.5H13.5V18Z" fill="#FFD99C" />

      <g
        style={{
          mixBlendMode: "color",
        }}
      >
        <path
          d="M21 24V22.5H19.5V19.5H18V18H16.5V19.5H15V16.5H16.5V15H18V13.5H19.5V10.5H18V7.5H19.5V1.5H18V3H16.5V6H12V1.5H10.5V3H9V4.5H7.5V7.5H9V16.5H12V18H10.5V19.5H9V21H7.5V22.5H6V24H21Z"
          fill={color as string}
        />
      </g>
    </Icon>
  );
};
